import { useMutation } from 'react-query';
import hooks from '../../hooks'

export const useCoursesPatcher = ({
    onSuccess = () => {}
}) => {
    const cacheKeys = hooks.useCacheKeys();
    const { clearCache } = hooks.useCache({ key: cacheKeys.COURSES, onReload: onSuccess})
    const { api, endpoints } = hooks.useApi();
    const toaster = hooks.useToasts();
    const [ mutate, { isLoading: isBusy }]  = useMutation(
        (courses = []) => api.patch(endpoints.courses, {courses}),
        {
            onSuccess: clearCache,
            onError: () => toaster.error('Error updating experiences')
        }
    );

    const patchCourses = (courses = [], patchObject) => {
        const c = courses.map( c => ({ id: c.id, ...patchObject }))
        mutate(c)
    }


    return {
        isBusy,
        patchCourses
    };
};
